// A slender birch: a thin near-white trunk under a small, airy, light-green
// canopy. Tall and delicate. Ported 1:1 from age-of-mcp's classic tree-birch.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.045, 0.06, 1.1, 6),
      color: "#e6e3d8", position: [0, 0.55, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.4, 0),
      color: "#7ab84e", position: [0, 1.34, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.28, 0),
      color: "#8fc961", position: [-0.22, 1.16, 0.1] },
    { geometry: new THREE.IcosahedronGeometry(0.24, 0),
      color: "#6ba844", position: [0.22, 1.5, -0.1] },
  ];
}

export const treeBirch = defineModel({
  id: "tree-birch",
  batchId: "standard",
  name: "Tree birch",
  tags: ["scenery","tree","birch","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree birch.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => partsFor(),
  animations: [],
});
